import React from 'react'
import { IonItem, IonItemOption, IonItemOptions, IonItemSliding, IonLabel, IonNote, IonToggle } from '@ionic/react';

//	L O C A L E

import { locale___ComDigitalMenuDishComponent } from './com-digitalmenu-dish.locale';

//	S T Y L E

import './com-digitalmenu-dish.scss'

//	S T A T E   -   P R O P S

import { props___ComDigitalMenuDishComponent, state___ComDigitalMenuDishComponent, state___ComDigitalMenuDishComponent___default } from './com-digitalmenu-dish.state';

//	F U N C S

import { funcs_measurements } from '../../funcs/funcs.measurements';
import { funcs_numbers } from '../../funcs/funcs.numbers';

//	S E R V I C E S

import { service_LocalizationService } from '../../services/service-localization';

//	C L A S S

export default class ComDigitalMenuDishComponent extends React.Component<props___ComDigitalMenuDishComponent, state___ComDigitalMenuDishComponent> {

//#region 																							H A N L D E R S

	private readonly _LOCALE: service_LocalizationService = new service_LocalizationService();

	private readonly funcs___measurements: funcs_measurements = new funcs_measurements();
	private readonly funcs___numbers: funcs_numbers = new funcs_numbers();

//#endregion

//#region 																							C O N S T R U C T O R

	constructor(
		public props: props___ComDigitalMenuDishComponent,
	) {
		super(props);
		this.state = state___ComDigitalMenuDishComponent___default;
	}

//#endregion

//#region 																							H A N D L E R S

	private handle___dish___activate = (___e: any) => {
		const ___is_checked: boolean = ___e.target.checked;
		this.setState({
			dish_active: ___is_checked,
		}, () => {
			this.props.event___onVisibilityChange(this.state.dish_active);
		});
	}

//#endregion

//#region 																							L I F E C Y C L E

	componentDidMount() : void {
		this.setState({
			dish_active: this.props.dish_props['dish_active'] as boolean,
		});
	}

//#endregion

//#region 																							R E N D E R

	render() : React.ReactNode {
		const ___checkbox_id: string = 'com-digitalmenu-dish---checkbox---' + this.props.dish_props['dish_id'];
		return <>
			<IonItemSliding>
				
				<IonItem className="com-digitalmenu-dish---container">
					<IonNote slot="start" color="primary">
						<label htmlFor={___checkbox_id}>
							<input style={{display:'none'}} type="checkbox" id={___checkbox_id} defaultChecked={ this.state.dish_active } checked={ this.state.dish_active } onChange={ this.handle___dish___activate }/>
							{(this.state.dish_active === true) ? <>
								<i className="fas fa-eye" style={{color:'var(--color---greeny)'}}></i>
							</> : <>
								<i className="fas fa-eye-slash" style={{color:'var(--color---reddy)'}}></i>
							</>}
						</label>
					</IonNote>
					<IonLabel onClick={() => { this.props.event___onClick(this.props.dish_props['dish_id']); }}>{ this.props.dish_props['dish_name'] }</IonLabel>
					<IonNote slot="end" color="primary" onClick={() => { this.props.event___onClick(this.props.dish_props['dish_id']); }}>
						{(this.props.dish_props['dish_measurement_unit'] && this.props.dish_props['dish_measurement_unit'] !== null) ? <>
							<b>{ this.funcs___numbers.format___price(this.props.dish_props['dish_price'], '€') }</b>
							<span> { this.funcs___measurements.price_at_measurements(this.props.dish_props['dish_measurement_unit'], false) }</span>
						</> : <>
							<b>{ this.funcs___numbers.format___price(this.props.dish_props['dish_price'], '€') }</b>
						</>}
					</IonNote>
				</IonItem>
		
				<IonItemOptions side="end">
					<IonItemOption color="danger">
						<span style={{padding:'0 10pt'}} onClick={() => { this.props.event___onDelete(); }}>{ this._LOCALE.translate(locale___ComDigitalMenuDishComponent.delete) }</span>
					</IonItemOption>
				</IonItemOptions>

			</IonItemSliding>
		</>;
	}

//#endregion

}